import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye-fill",
  "use": "icon-eye-fill-usage",
  "viewBox": "0 0 291 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 291 200\" id=\"icon-eye-fill\">\n<path d=\"M144.1,8.5C61.4,8.5,9.8,100,9.8,100s51.1,91.5,134.3,91.5c77.8,0,136.8-91.5,136.8-91.5S222.3,8.5,144.1,8.5L144.1,8.5z\n\t M144.8,136.6c-20.1,0-36.4-16.4-36.4-36.5s16.3-36.5,36.4-36.5s36.4,16.4,36.4,36.5S164.9,136.6,144.8,136.6L144.8,136.6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol